<template>
    <custom-nav class="custom-nav" logo_img="../../img/logo_nav.png" img_route="/" :link_routes=link_routes :user_routes=user_routes :connected="isConnected" />
</template>

<script>
    import {CustomNav} from "@vues/v-common";
    import {RightService} from "@/services/RightService";

    // Sous-menus dont l'adresse ne commence pas par celle de leur onglet
    const SECTION_PREFIXES = {
      '/purchases': ['/purchase-'],
      '/marketing': ['/marketing-'],
      '/facture-x-dashboard': ['/facture-x-'],
      '/accounting': ['/collections', '/accounting-'],
    };

    export default {
        name: 'ConfiguratedNav',
        components: {
          CustomNav
        },
        data: function() {
            return {
                link_routes: [],
                user_routes: [],
                isConnected: localStorage && localStorage.isConnected === "true"
            };
        },
        mounted(){
          // This event is call for rerender the navbar when the connection state change
          window.addEventListener('isConnectedChange', (event) => {
            this.isConnected = event.detail.isConnected;
            this.setRoutes();
          });
          this.setRoutes();
        },
        watch: {
          // Une sous-page (ex. /dossiers/12) garde l'onglet de sa rubrique allumé
          '$route.path'() {
            this.markActiveTab();
          },
          link_routes() {
            this.markActiveTab();
          }
        },
        methods: {
          // Repère l'onglet de la rubrique affichée par un attribut (les classes, elles, sont gérées par le routeur)
          // Adresses de sous-menus qui n'ont pas pour préfixe celle de leur onglet (ex. /purchase-suppliers pour Achats)
          // : l'onglet reste marqué actif quand on change de sous-menu
          markActiveTab() {
            this.$nextTick(() => {
              const path = this.$route.path;
              let best;
              let bestLength = -1;
              document.querySelectorAll('nav.custom-nav .navbar-text a.nav-link').forEach(link => {
                link.removeAttribute('data-tab-active');
                const href = link.getAttribute('href') || '';
                const prefixes = SECTION_PREFIXES[href] || [];
                if ((path === href || path.startsWith(href + '/') || prefixes.some(prefix => path.startsWith(prefix))) && href.length > bestLength) {
                  best = link;
                  bestLength = href.length;
                }
              });
              if (best) best.setAttribute('data-tab-active', '');
            });
          },
          setRoutes() {
            this.user_routes = [];
            this.link_routes = [];
            if (localStorage && localStorage.isConnected === "true") {
              this.user_routes.push({name: "Paramètre du compte", route: "/user-parameters"});
              this.user_routes.push({name: "Paramètre du groupe", route: "/group-parameters"});
              this.user_routes.push({name: "Déconnexion", route: "/logout"});

              if(localStorage.options && localStorage.options.includes("business")) {
                this.link_routes.push({name: "Clients", route: "/clients"});
                this.link_routes.push({name: "Prestations", route: `/businesses`});
              }

              if(localStorage.options && localStorage.options.includes("production")) {
                this.link_routes.push({name: "Dossiers", route: "/dossiers"});
              }

              if(localStorage.options && localStorage.options.includes("accountant")) {
                this.link_routes.push({name: "Professionnels", route: "/professionals"});
                this.link_routes.push({name: "Comptabilité", route: "/accounting"});
              }

              if(localStorage.options && localStorage.options.includes("accounting")) {
                this.link_routes.push({name: "Comptabilité", route: "/accounting"});
              }

              if(localStorage.options && localStorage.options.includes("statistics")) {
                this.link_routes.push({name: "Statistiques", route: "/statistics"});
              }

              if(localStorage.options && localStorage.options.includes("purchase")) {
                this.link_routes.push({name: "Achats", route: "/purchases"});
              }

              if(localStorage.options && localStorage.options.includes("marketing")) {
                this.link_routes.push({name: "Marketing", route: "/marketing"});
              }

              if(localStorage.options && localStorage.options.includes("invoice_transmission")) {
                this.link_routes.push({name: "Facturation électronique", route: "/facture-x-dashboard"});
              }

              if(localStorage.options && localStorage.options.includes("client")) {
                this.link_routes.push({name: "Prestations", route: "/businesses-for-client"});
              }

              if (RightService.isAtLeastModerator()) {
                this.link_routes.push({name: "Utilisateurs", route: "/users"});
              }

              if (RightService.isSuperAdmin()) {
                this.link_routes.push({name: "Administration", route: "/administration"});
              }
            } else {
              this.user_routes.push({name: "Créer mon compte", route: "/register"});
              this.user_routes.push({name: "Connexion", route: "/login"});
            }
          }
        }
    }
</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';
</style>

<style lang="stylus">
  .custom-nav
    --THEME_COLOR_NAV_HEADER #17233f !important
</style>
